import React from "react";
import moment from "moment";
import { ScheduledSongCardStyle } from "./ScheduledSongCard.style";

interface ScheduledSongCardProps {
  song: any;
  actionType: "adding" | "removing";
  onClick: (song: any) => void;
}

const ScheduledSongCard: React.FC<ScheduledSongCardProps> = ({ 
  song, 
  actionType, 
  onClick 
}) => {
  const getSongImage = () => {
    // Add comprehensive null checks for nested array access
    if (song?.spotifyData?.album?.images && Array.isArray(song.spotifyData.album.images) && song.spotifyData.album.images.length > 0 && song.spotifyData.album.images[0]?.url) {
      return song.spotifyData.album.images[0].url;
    }
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect width='200' height='200' fill='%23333'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='60' fill='white' text-anchor='middle' dy='.3em'%3E♪%3C/text%3E%3C/svg%3E";
  };
  
  const getSongName = () => {
    return song?.song_name || song?.spotifyData?.name || "Unknown Song";
  };
  
  const getArtistName = () => {
    // Add comprehensive null checks for artists array
    return song?.artist_name 
      || (Array.isArray(song?.spotifyData?.artists) && song.spotifyData.artists.length > 0 && song.spotifyData.artists[0]?.name) 
      || "Unknown Artist";
  };
  
  const getScheduleDate = () => {
    const date = actionType === "adding" ? song?.start_time : song?.end_time;
    return date ? moment(date).format("MMM DD, YYYY [at] hh:mm A") : "Not scheduled";
  };
  
  const getPlaylistName = () => {
    // This would need to be fetched or passed as prop
    return song?.playlistName || "Playlist";
  };
  
  return (
    <ScheduledSongCardStyle 
      className={`action-${actionType}`}
      onClick={() => onClick(song)}
    >
      <div className="card-image-wrapper">
        <img src={getSongImage()} alt={getSongName()} className="card-image" />
        <div className={`action-badge ${actionType}`}>
          {actionType === "adding" ? "+" : "−"}
        </div>
      </div>
      
      <div className="card-content">
        <h3 className="song-name">{getSongName()}</h3>
        <p className="artist-name">{getArtistName()}</p>
        
        <div className="schedule-info">
          <div className="info-row">
            <span className="info-label">Playlist:</span>
            <span className="info-value">{getPlaylistName()}</span>
          </div>
          <div className="info-row">
            <span className="info-label">
              Scheduled for:
            </span>
            <span className="info-value">{getScheduleDate()}</span>
          </div>
          {song.notes && (
            <div className="info-row notes">
              <span className="info-label">Note:</span>
              <span className="info-value">{song.notes}</span>
            </div>
          )}
        </div>
      </div>
    </ScheduledSongCardStyle>
  );
};

export default ScheduledSongCard;

